import { FccWaypointState } from '@backoffice-frontend/graphql'
import type { AdVehicleStreamEvaluateCabinSafetyCheckStatusFragment } from './evaluateCabinSafetyCheckStatus.hook'

export const evaluateCabinSafetyCheckStatus = (
  waypoint?: AdVehicleStreamEvaluateCabinSafetyCheckStatusFragment,
): { isStandaloneCabinSafetyCheck: boolean; hasPickup: boolean } => {
  if (!waypoint) {
    return { isStandaloneCabinSafetyCheck: false, hasPickup: false }
  }

  const isAtWaypoint =
    waypoint.adState === FccWaypointState.Reached ||
    waypoint.adState === FccWaypointState.Completed

  const hasPickup = waypoint.actions.some(
    action => action.__typename === 'FccWaypointPickupAction',
  )
  const hasDropoff = waypoint.actions.some(
    action => action.__typename === 'FccWaypointDeliveryAction',
  )
  const hasPickupOrDropOff = hasPickup || hasDropoff
  const isAttendingWaypoint = isAtWaypoint && hasPickupOrDropOff
  const isStandaloneCabinSafetyCheck = !isAttendingWaypoint
  return { isStandaloneCabinSafetyCheck, hasPickup }
}
